import EFPic from '@/components/UI/EFPic';
import EFCSR from '@/components/UI/svg/CSR/Icons/EFCSR';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { TweenMax } from 'gsap';

export default function A() {
    const { useLang, useEffect, useState } = useGlobal();
    const { t } = useLang('csr');
    const [show, setShow] = useState(false)

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        // const layoutH = typeof window !== 'undefined' ? window?.innerHeight : 750;

        // const tween = TweenMax.fromTo('.csr_h5_A .topTextBox', 2, { opacity: 0 }, { opacity: 0 });
        // const tween0 = TweenMax.fromTo('.csr_h5_A .topTextBox', 0.01, { opacity: 0 }, { opacity: 1 });
        // // 副标题淡入动画　スクロルアニメ（ScrollMagicの動画)
        // const tween1 = TweenMax.to('.csr_h5_A .guide', 0.5, { css: { top: 0, opacity: 1}, ease: "cubic-bezier(0.16, 0.00, 0.32, 1.00)" });
        // // 标题淡入动画 ： .letter  => 目标元素 0.5 => 动画持续时长（单个）0.5s {top:100, ...} => 动画前的css {top: 0, ...} => 动画后的css, 0.15 => 动画数组间隔时间 0.15s
        // const tween2 = TweenMax.staggerFromTo(
        //     '.letter',
        //     1,
        //     { css: { top: 80, opacity: 0 } },
        //     { css: { top: 0, opacity: 1 }, stagger: 0.067, ease: "cubic-bezier(0.16, 0.00, 0.32, 1.00)" },
        //     0.067,
        // );
        // // 签字svg
        // const tween3 = TweenMax.to('.csr_h5_A .svgInner', 1, { width: '100%' })


        // // 签字
        // const target = document.querySelector('#EFCSR') as SVGGeometryElement;
        // if (target) {
        //     const lineLength = target.getTotalLength();
        //     target.style.strokeDasharray = lineLength + 'px';
        //     target.style.strokeDashoffset = lineLength + 'px';
        // }
        // // 签字动画
        // const tween3 = TweenMax.to('.csr_h5_A #EFCSR', 1, { strokeDashoffset: 0 });
        // const tween4 = TweenMax.to('path', 1, { stroke: '#33629c' });
        // const timeline = new TimelineMax().add(tween).add(tween0).add(tween1, 0.2).add(tween2, 0.5).add(tween3);

        // new ScrollMagic.Scene({
        //     triggerElement: '.csr_h5_A',
        //     triggerHook: 1,
        //     offset: layoutH,
        // })
        //     .setTween(timeline)
        //     .addTo(controller);
        setTimeout(()=>{
            if(!show){
                setShow(true)
            }
        }, 1000)

        new ScrollMagic.Scene({
            triggerElement: '.csr_h5_A',
            triggerHook: 1,
            // offset: layoutH,
        })
            .setClassToggle('.csr_h5_A .innerBox', 'enter')
            .addTo(controller);

        // csr_h5_A元素离开视窗开始到200px， topTextBox元素向下位移25px
        new ScrollMagic.Scene({
            triggerElement: '.csr_h5_A',
            triggerHook: 0,
            duration: 200,
        })
            .setTween(TweenMax.to('.csr_h5_A .topTextBox', 0.5, { y: 25 }))
            .addTo(controller);
    }, []);

    const titleLetters: [string] = t('secA_title').split('');

    return (
        <div className={`csr_h5_A ${css.csr_h5_A} ${show ? 'show' : ''}`}>
            <div className="innerBox">
                <EFPic src={['/img/csr/h5/1_bg.webp', '/img/csr/h5/1_bg.jpg']} alt={t('secA_title')} aria-label={t('secA_title')} />
                <div className="topTextBox">
                    <p className="guide">{t('secA_guide')}</p>
                    <p className="title">
                        {titleLetters?.map((letter: string, k: number) => (
                            <span className={`letter_A letter_${k}`} key={k}>
                                {letter}
                            </span>
                        ))}
                    </p>
                    <div className="svgBox">
                        <div className="svgInner">
                            <EFCSR width="1.93rem" height="0.36rem" />
                        </div>
                    </div>
                </div>
                <div className="imgBox">
                    <div className="img">
                        <EFPic src={['/img/csr/h5/1.webp', '/img/csr/h5/1.jpg']} alt={t('secA_title')} aria-label={t('secA_title')}/>
                    </div>
                </div>
                <div className="botTextBox">
                    <p className="text">{t('secA_text')}</p>
                </div>
            </div>
        </div>
    );
}
